export const maintenanceScheduledescription = {
    title: "Your Subaru Maintenance Schedule",
    narrative: "The most accurate recommended maintenance intervals are based on mileage \
    or time since the last service- whichever occurs first. For simplicity, the intervals are shown \
    and mileage only and are the recommended minimums. A more frequent maintenance schedule, referred \
    to as the Severe maintenance schedule, may be needed depending on road conditions, weather and individual driving habits*, \
    to name a few. See your Warranty & Maintenance Booklet for more details.",
    severeTitle: "*Examples of Severe Driving Conditions",
    severeItemsListOne: [
        "Repeated short distance driving",
        "Driving on rough and/or muddy roads",
        "Driving in dusty conditions",
        "Driving in extremely cold weather",
    ],
    severeItemsListTwo: [
        "Living in coastal areas",
        "Driving in areas where road salts or other corrosive materials are used",
        "Repeated trailer towing",
    ],
};
